import {FC} from "react";
import {useTranslation} from "react-i18next";
import {
  SimpleTable,
  TableBody,
  TableRow,
  TableCell
} from "@interstate/components/SimpleTable";
import {OrganizationInformationInput} from "@common-core/coat-operational-hierarchy-appsync-model";
import {TabRow} from "../../../../../tab-content";

export interface BusinessInformationProps {
  organizationInformation: OrganizationInformationInput;
}

export const BusinessInformationRow: FC<BusinessInformationProps> = ({
  organizationInformation
}) => {
  const {t} = useTranslation();
  return (
    <TabRow
      name={"business-information"}
      header={<h4>{t("entity-detail.dealer.business-information")}</h4>}>
      <SimpleTable
        id={"business-information-table"}
        data-testid={"business-information-table"}
        dataDensity={"small"}
        background={"white"}
        className={"business-information-table"}
        bordered={false}
        hover={false}
        striped={false}>
        <TableBody>
          <TableRow>
            <TableCell className={"information-field"}>
              {t("entity-detail.dealer.legal-name")}
            </TableCell>
            <TableCell
              id={"dealer-information-legal-name"}
              className={"information-value"}>
              {organizationInformation.legalName}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={"information-field"}>
              {t("entity-detail.dealer.dba-name")}
            </TableCell>
            <TableCell
              id={"dealer-information-dba-name"}
              className={"information-value"}>
              {organizationInformation.dbaName}
            </TableCell>
          </TableRow>
        </TableBody>
      </SimpleTable>
    </TabRow>
  );
};
